import createClient, { type Client } from "openapi-fetch";
import type { paths } from "./generated/schema.ts";

export interface ApiClientOptions {
  /** Base URL of the jod_api server, e.g. `import.meta.env.VITE_API_BASE_URL`. */
  baseUrl: string;
  /**
   * Returns an auth token to attach as `Authorization: Bearer <token>`.
   * For the customer app this resolves to the LINE access/ID token; for staff/
   * owner apps, the staff session token. Verification happens server-side —
   * the client never trusts its own identity claims.
   */
  getAuthToken?: () => string | undefined | Promise<string | undefined>;
}

export type JodApiClient = Client<paths>;

/** Create a type-safe API client bound to a base URL and optional auth. */
export function createApiClient({ baseUrl, getAuthToken }: ApiClientOptions): JodApiClient {
  const client = createClient<paths>({ baseUrl });

  if (getAuthToken) {
    client.use({
      async onRequest({ request }) {
        const token = await getAuthToken();
        if (!token) {
          return undefined;
        }
        const headers = new Headers(request.headers);
        headers.set("Authorization", `Bearer ${token}`);
        return new Request(request, { headers });
      },
    });
  }

  return client;
}
